"use client"

import Link from "next/link"
import { Phone, Mail, MapPin } from "lucide-react"
import { useSettings } from "@/lib/settings-context"

const services = [
  "Horizontal Directional Drilling",
  "Micro Trenching",
  "Fiber Pulling",
  "Fiber Splicing",
  "Aerial Installation",
  "Underground Installation",
]

const quickLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/gallery", label: "Project Gallery" },
  { href: "/contact", label: "Contact" },
]

export function Footer() {
  const { settings } = useSettings()
  
  // Convert phone number for tel: link (remove formatting)
  const telLink = settings.phoneNumber.replace(/\D/g, '')
  
  return (
    <footer className="border-t border-border/40 bg-card">
      <div className="container mx-auto px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground">World Connections LLC</h3>
            <p className="text-sm text-muted-foreground">
              Professional network infrastructure solutions. Specializing in HDD, fiber optics, and underground utilities since 2024.
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <MapPin className="h-4 w-4 text-primary" />
              <span>{settings.address}</span>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service} className="text-sm text-muted-foreground">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-primary"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground">Contact Us</h3>
            <div className="space-y-3">
              <a
                href={`tel:+${telLink}`}
                className="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                <Phone className="h-4 w-4 text-primary" />
                <span>{settings.phoneNumber}</span>
              </a>
              <a
                href={`mailto:${settings.email}`}
                className="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                <Mail className="h-4 w-4 text-primary" />
                <span>{settings.email}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-border/40 pt-6">
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} World Connections LLC. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground">
              Proudly serving Michigan and beyond.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
